import { call, put, takeLatest } from "@redux-saga/core/effects";
import { CoupanCityApi } from "./CoupanCityApi";
import { CoupanCityConstant } from "./CoupanCityConstant";
import { CoupanCityParser } from "./CoupanCityParser";

function* CoupanCitySaga() {
  try {
    yield put({ type: CoupanCityConstant.COUPAN_CITY_REQUEST });
    const res = yield call(CoupanCityApi.getCoupanCityApi);

    const payload = CoupanCityParser.getCouponParser(res);

    yield put({
      type: CoupanCityConstant.COUPAN_CITY_RESPONSE,
      payload: res,
    });
  } catch (e) {
    console.log("Error", e);
    yield put({
      type: CoupanCityConstant.COUPAN_CITY_RESPONSE,
      payload: [],
    });
  }
}

function* postCoupanModelSaga(payload) {

  try {
    yield put({ type: CoupanCityConstant.POST_ADD_COUPAN_MODEL_REQUEST });

    const res = yield call(CoupanCityApi.postAddCoupanModel, payload);


    yield put({
      type: CoupanCityConstant.POST_ADD_COUPAN_MODEL_RESPONSE,
      payload: res,
    });
  } catch (e) {
    console.log("Error", e);
    yield put({
      type: CoupanCityConstant.POST_ADD_COUPAN_MODEL_RESPONSE,
      payload: [],
    });
  }
}

//delete
function* CoupanCityDeleteSaga(payload) {
  const { id } = payload;

  try {
    yield put({ type: CoupanCityConstant.COUPAN_CITY_DELETE_REQUEST });
    const res = yield call(CoupanCityApi.getCoupanCityDeleteApi, id);
    const payload = res;
    yield put({
      type: CoupanCityConstant.COUPAN_CITY_DELETE_RESPONSE,
      payload: payload,
    });
  } catch (e) {
    yield put({
      type: CoupanCityConstant.COUPAN_CITY_DELETE_RESPONSE,
      payload: [],
    });
  }
}

function* ChargingNetworkDeleteSaga(payload) {
  const { id } = payload;

  try {
    yield put({ type: CoupanCityConstant.CHARGING_NETWORK_DELETE_REQUEST });
    const res = yield call(CoupanCityApi.getChargingNetworkDeleteApi, id);
    const payload = res;
    yield put({
      type: CoupanCityConstant.CHARGING_NETWORK_DELETE_RESPONSE,
      payload: payload,
    });
  } catch (e) {
    yield put({
      type: CoupanCityConstant.CHARGING_NETWORK_DELETE_RESPONSE,
      payload: [],
    });
  }
}

function* getSelectCouponCity() {
  try {
    yield put({ type: CoupanCityConstant.GET_SELECT_COUPON_CITY_REQUEST });
    const res = yield call(CoupanCityApi.getSelectCouponCityApi);

    yield put({
      type: CoupanCityConstant.GET_SELECT_COUPON_CITY_RESPONSE,
      payload: res,
    });
  } catch (e) {
    console.log("Error", e);
    yield put({
      type: CoupanCityConstant.GET_SELECT_COUPON_CITY_RESPONSE,
      payload: [],
    });
  }
}

function* getSelectChargingNetworksaga() {
  try {
    yield put({ type: CoupanCityConstant.GET_SELECT_CHARGING_NETWORK_REQUEST });
    const res = yield call(CoupanCityApi.getSelectChargingNetworkApi);

    yield put({
      type: CoupanCityConstant.GET_SELECT_CHARGING_NETWORK_RESPONSE,
      payload: res,
    });
  } catch (e) {
    console.log("Error", e);
    yield put({
      type: CoupanCityConstant.GET_SELECT_CHARGING_NETWORK_RESPONSE,
      payload: [],
    });
  }
}

export function* registerCoupanCitySaga() {
  yield takeLatest(CoupanCityConstant.COUPAN_CITY_SAGA, CoupanCitySaga);
  yield takeLatest(
    CoupanCityConstant.POST_ADD_COUPAN_MODEL_SAGA,
    postCoupanModelSaga
  );
  yield takeLatest(
    CoupanCityConstant.COUPAN_CITY_DELETE_SAGA,
    CoupanCityDeleteSaga
  );
  yield takeLatest(
    CoupanCityConstant.COUPAN_CITY_DELETE_SAGA,
    CoupanCityDeleteSaga
  );
  yield takeLatest(
    CoupanCityConstant.CHARGING_NETWORK_DELETE_SAGA,
    ChargingNetworkDeleteSaga
  );
  yield takeLatest(
    CoupanCityConstant.GET_SELECT_COUPON_CITY_SAGA,
    getSelectCouponCity
  );
  yield takeLatest(
    CoupanCityConstant.GET_SELECT_CHARGING_NETWORK_SAGA,
    getSelectChargingNetworksaga
  );
}
